import { tw } from "@careinfo/tailwind";
import { useFormContext, useWatch } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import MultipleSelectField from "../Reusable/MultiSelectField";

export default function ({
  profile,
  clientType,
}: {
  profile: Record<string, any>;
  clientType: any;
}) {
  const {
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    watch,
  } = useFormContext();

  return (
    <Card title={`Rate List`}>
      <div className={tw`w-full grid grid-cols-3 gap-x-4`}>
        <ComboboxInput
          url={APIS.BRANCH}
          props={{ merchant_service_branch: profile?.id, is_active: true }}
          queryKey={"local-branch"}
          register={register("local_branch")}
          errors={errors?.local_branch}
          name={"local_branch"}
          label={"Origin Branch"}
          setValue={setValue}
          placeholder={"Branch"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.SERVICE_TYPE}
          props={{ merchant_service_types: profile?.id, is_active: true }}
          queryKey={"local-service"}
          register={register("local_service")}
          errors={errors?.local_branch}
          name={"local_service"}
          label={"Service Type"}
          setValue={setValue}
          placeholder={"Service Type"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <MultipleSelectField
          label={"Product Type"}
          queryKey={"product-type"}
          register={register("localProduct_type")}
          watch={watch}
          setValue={setValue}
          errors={errors?.localProduct_type}
          clearErrors={clearErrors}
          props={{
            is_active: true,
            ...(clientType === "cargo"
              ? {
                  is_shipment_type: true,
                }
              : {
                  is_shipment_type: false,
                }),
          }}
          url={APIS.PRODUCT_TYPE}
          value={
            clientType === "cargo"
              ? []
              : profile?.product_type?.map((item: any) => ({
                  label: item?.name,
                  value: item?.id,
                }))
          }
        />
      </div>
    </Card>
  );
}
